const HostingEntitiesMapping = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="10" fill="#437EF7" fill-opacity="0.25" />
    <path
      d="M18 21C17.8019 20.9974 17.6128 20.9177 17.4727 20.7776C17.3326 20.6375 17.2526 20.4481 17.25 20.25V18.25C17.25 18.0511 17.3291 17.8604 17.4697 17.7197C17.6104 17.5791 17.8011 17.5 18 17.5C18.1989 17.5 18.3896 17.5791 18.5303 17.7197C18.6709 17.8604 18.75 18.0511 18.75 18.25V20.25C18.75 20.4489 18.6709 20.6399 18.5303 20.7805C18.3896 20.9212 18.1989 21 18 21Z"
      fill="#437EF7"
    />
    <path
      d="M22 21C21.8019 20.9974 21.6128 20.9177 21.4727 20.7776C21.3326 20.6375 21.2526 20.4481 21.25 20.25V18.25C21.25 18.0511 21.3291 17.8604 21.4697 17.7197C21.6104 17.5791 21.8011 17.5 22 17.5C22.1989 17.5 22.3896 17.5791 22.5303 17.7197C22.6709 17.8604 22.75 18.0511 22.75 18.25V20.25C22.75 20.4489 22.6709 20.6399 22.5303 20.7805C22.3896 20.9212 22.1989 21 22 21Z"
      fill="#437EF7"
    />
    <path
      d="M27 34.75H21C15.57 34.75 13.25 32.43 13.25 27V21C13.25 15.56 15.57 13.25 21 13.25H27C32.44 13.25 34.75 15.56 34.75 21V27C34.75 32.43 32.44 34.75 27 34.75ZM21 14.75C16.39 14.75 14.75 16.38 14.75 21V27C14.75 31.61 16.39 33.25 21 33.25H27C31.62 33.25 33.25 31.61 33.25 27V21C33.25 16.38 31.62 14.75 27 14.75H21Z"
      fill="#437EF7"
    />
    <path
      d="M18 30.75C17.8019 30.7474 17.6128 30.6677 17.4727 30.5276C17.3326 30.3875 17.2526 30.1981 17.25 30V28C17.25 27.8011 17.3291 27.6104 17.4697 27.4697C17.6104 27.3291 17.8011 27.25 18 27.25C18.1989 27.25 18.3896 27.3291 18.5303 27.4697C18.6709 27.6104 18.75 27.8011 18.75 28V30C18.75 30.1989 18.6709 30.3899 18.5303 30.5305C18.3896 30.6712 18.1989 30.75 18 30.75Z"
      fill="#437EF7"
    />
    <path
      d="M22 30.75C21.8019 30.7474 21.6128 30.6677 21.4727 30.5276C21.3326 30.3875 21.2526 30.1981 21.25 30V28C21.25 27.8011 21.3291 27.6104 21.4697 27.4697C21.6104 27.3291 21.8011 27.25 22 27.25C22.1989 27.25 22.3896 27.3291 22.5303 27.4697C22.6709 27.6104 22.75 27.8011 22.75 28V30C22.75 30.1989 22.6709 30.3899 22.5303 30.5305C22.3896 30.6712 22.1989 30.75 22 30.75Z"
      fill="#437EF7"
    />
    <path
      d="M30 20H26C25.8011 20 25.6104 19.9212 25.4697 19.7805C25.3291 19.6399 25.25 19.4489 25.25 19.25C25.25 19.0511 25.3291 18.8604 25.4697 18.7197C25.6104 18.5791 25.8011 18.5 26 18.5H30C30.1989 18.5 30.3896 18.5791 30.5303 18.7197C30.6709 18.8604 30.75 19.0511 30.75 19.25C30.75 19.4489 30.6709 19.6399 30.5303 19.7805C30.3896 19.9212 30.1989 20 30 20Z"
      fill="#437EF7"
    />
    <path
      d="M30 29.75H26C25.8011 29.75 25.6104 29.6712 25.4697 29.5305C25.3291 29.3899 25.25 29.1989 25.25 29C25.25 28.8011 25.3291 28.6104 25.4697 28.4697C25.6104 28.3291 25.8011 28.25 26 28.25H30C30.1989 28.25 30.3896 28.3291 30.5303 28.4697C30.6709 28.6104 30.75 28.8011 30.75 29C30.75 29.1989 30.6709 29.3899 30.5303 29.5305C30.3896 29.6712 30.1989 29.75 30 29.75Z"
      fill="#437EF7"
    />
    <path
      d="M34 24.75H14C13.8011 24.75 13.6104 24.6712 13.4697 24.5305C13.3291 24.3899 13.25 24.1989 13.25 24C13.25 23.8011 13.3291 23.6104 13.4697 23.4697C13.6104 23.3291 13.8011 23.25 14 23.25H34C34.1989 23.25 34.3896 23.3291 34.5303 23.4697C34.6709 23.6104 34.75 23.8011 34.75 24C34.75 24.1989 34.6709 24.3899 34.5303 24.5305C34.3896 24.6712 34.1989 24.75 34 24.75Z"
      fill="#437EF7"
    />
  </svg>
);
export default HostingEntitiesMapping;
